import { render, staticRenderFns } from "./AddNewOrder.vue?vue&type=template&id=2bbf541a&scoped=true&"
import script from "./AddNewOrder.vue?vue&type=script&lang=ts&"
export * from "./AddNewOrder.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewOrder.vue?vue&type=style&index=0&id=2bbf541a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf541a",
  null
  
)

export default component.exports